import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';

const BUYER_ROUTES = [
  '/sugar-marketplace-dashboard',
  '/buyer-operations-dashboard',
  '/truck-marketplace',
  '/live-shipment-tracking',
];

const BreadcrumbNavigation = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const routeMapping = {
    '/login-authentication': { label: 'Login', parent: null },
    '/sugar-marketplace-dashboard': { label: 'Sugar Marketplace', parent: null },
    '/truck-marketplace': { label: 'Truck Marketplace', parent: null },
    '/buyer-operations-dashboard': { label: 'Buyer Operations', parent: null },
    '/transporter-dashboard': { label: 'Transporter Dashboard', parent: null },
    '/admin-control-panel': { label: 'Admin Control Panel', parent: null }
  };

  const generateBreadcrumbs = () => {
    const pathSegments = location?.pathname?.split('/')?.filter(Boolean);
    const breadcrumbs = [{ label: 'Home', path: '/' }];

    let currentPath = '';
    pathSegments?.forEach((segment) => {
      currentPath += `/${segment}`;
      const route = routeMapping?.[currentPath];
      if (route) {
        breadcrumbs?.push({
          label: route?.label,
          path: currentPath
        });
      }
    });

    return breadcrumbs;
  };

  const breadcrumbs = generateBreadcrumbs();

  const handleBreadcrumbClick = (path, index) => {
    if (path !== location?.pathname) {
      // If clicking "Home" and we're on a buyer route, go to Buyer Dashboard
      if (index === 0 && BUYER_ROUTES?.includes(location?.pathname)) {
        navigate('/buyer-operations-dashboard');
        return;
      }
      navigate(path);
    }
  };

  if (breadcrumbs?.length <= 1) {
    return null;
  }

  return (
    <nav className="breadcrumb-container" aria-label="Breadcrumb">
      {breadcrumbs?.map((crumb, index) => (
        <React.Fragment key={crumb?.path}>
          {index > 0 && (
            <Icon name="ChevronRight" size={16} className="breadcrumb-separator" />
          )}
          <button
            onClick={() => handleBreadcrumbClick(crumb?.path, index)}
            className={`breadcrumb-item ${
              index === breadcrumbs?.length - 1 ? 'active' : ''
            }`}
            aria-current={index === breadcrumbs?.length - 1 ? 'page' : undefined}
            disabled={index === breadcrumbs?.length - 1}
          >
            {index === 0 && <Icon name="Home" size={16} className="mr-1" />}
            <span>{crumb?.label}</span>
          </button>
        </React.Fragment>
      ))}
    </nav>
  );
};

export default BreadcrumbNavigation;